import {
  stringifyEntityRef,
  CompoundEntityRef,
} from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { docsOwnershipApiRef } from '../api';

export const useDocPathOwnerEntity = (
  entityRef: CompoundEntityRef,
  path: string,
) => {
  const catalogApi = useApi(catalogApiRef);
  const docsOwnershipApi = useApi(docsOwnershipApiRef);
  const {
    data: owner,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ['docs-ownership', stringifyEntityRef(entityRef), path],
    queryFn: async () => {
      const ownerRef = await docsOwnershipApi.getDocPathOwnerRef(
        entityRef,
        path,
      );
      return ownerRef ? await catalogApi.getEntityByRef(ownerRef) : null;
    },
    refetchOnWindowFocus: false,
  });
  return {
    owner,
    isLoading,
    isFetching,
    isError,
    error: error as Error,
  };
};
